import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IonicModule } from '@ionic/angular';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.modal.html',
  styleUrls: ['./auth.modal.scss'],
  standalone: true,
  imports: [IonicModule, AmplifyAuthenticatorModule],
})
export class AuthModalComponent {
  public appVersion = environment.version;
  public logoSrc = './assets/imgs/app-icon.png';

  constructor() {}

}
